<div class="gallery-columns">
  <div class="gallery-col">
    <ng-container *ngFor="let block of leftCol">
      <!-- 1-image block -->
      <div *ngIf="block.length === 1" class="block block1">
        <img *ngIf="block[0]" [src]="block[0]" loading="lazy" class="block-img" />
      </div>
      <!-- 2-image block: 1:3 ratio -->
      <div *ngIf="block.length === 2" class="block block2h">
        <div class="block2h-col block2h-col1">
          <img *ngIf="block[0]" [src]="block[0]" loading="lazy" class="block-img" />
        </div>
        <div class="block2h-col block2h-col2">
          <img *ngIf="block[1]" [src]="block[1]" loading="lazy" class="block-img" />
        </div>
      </div>
      <!-- 3-image block: 40:60 columns, 2 stacked in 40%, 1 in 60% -->
      <div *ngIf="block.length === 3" class="block block3mix">
        <div class="block3mix-col block3mix-col1">
          <img *ngIf="block[0]" [src]="block[0]" loading="lazy" class="block-img" />
          <img *ngIf="block[1]" [src]="block[1]" loading="lazy" class="block-img" />
        </div>
        <div class="block3mix-col block3mix-col2">
          <img *ngIf="block[2]" [src]="block[2]" loading="lazy" class="block-img" />
        </div>
      </div>
    </ng-container>
  </div>
  <div class="gallery-col">
    <ng-container *ngFor="let block of rightCol">
      <!-- 1-image block -->
      <div *ngIf="block.length === 1" class="block block1">
        <img *ngIf="block[0]" [src]="block[0]" loading="lazy" class="block-img" />
      </div>
      <!-- 2-image block: 1:3 ratio -->
      <div *ngIf="block.length === 2" class="block block2h">
        <div class="block2h-col block2h-col1">
          <img *ngIf="block[0]" [src]="block[0]" loading="lazy" class="block-img" />
        </div>
        <div class="block2h-col block2h-col2">
          <img *ngIf="block[1]" [src]="block[1]" loading="lazy" class="block-img" />
        </div>
      </div>
      <!-- 3-image block: 40:60 columns, 2 stacked in 40%, 1 in 60% -->
      <div *ngIf="block.length === 3" class="block block3mix">
        <div class="block3mix-col block3mix-col1">
          <img *ngIf="block[0]" [src]="block[0]" loading="lazy" class="block-img" />
          <img *ngIf="block[1]" [src]="block[1]" loading="lazy" class="block-img" />
        </div>
        <div class="block3mix-col block3mix-col2">
          <img *ngIf="block[2]" [src]="block[2]" loading="lazy" class="block-img" />
        </div>
      </div>
    </ng-container>
  </div>
</div>
